var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruckDriving(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 24,
    viewBox: "0 0 39 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icon-stroke",
    fill: "none",
    stroke: "#7A7A7A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.802 4.615h5.849c.65 0 1.23.456 1.45 1.139l2.747 8.571c.286.892-.132 1.872-.932 2.19-.169.067-.346.101-.524.1h-1.291M11.005 16.615H9.372c-1.105 0-2-.895-2-2V2c0-1.105.895-2 2-2h14.43c1.104 0 2 .895 2 2v14.615h0H15.26",
    transform: "translate(1.418 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.99 16.368c.9.901.9 2.363 0 3.264-.899.901-2.358.901-3.257 0-.9-.901-.9-2.363 0-3.264.9-.901 2.358-.901 3.258 0M32.499 16.368c.9.901.9 2.363 0 3.264-.9.901-2.358.901-3.258 0-.9-.901-.9-2.363 0-3.264.9-.901 2.358-.901 3.258 0",
    transform: "translate(1.418 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.99 16.368c.9.901.9 2.363 0 3.264-.899.901-2.358.901-3.257 0-.9-.901-.9-2.363 0-3.264.9-.901 2.358-.901 3.258 0M0 8.299L4.607 8.316M.921 12L4.607 12M2.764 15.692L4.607 15.692M33.598 9.898L26.098 9.898M24.88 16.615L28.566 16.615",
    transform: "translate(1.418 1)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckDriving);
export default __webpack_public_path__ + "static/media/truck-driving.9bcea0e0.svg";
export { ForwardRef as ReactComponent };